import { createApolloClient } from "../store/createApolloClient";

export const client = createApolloClient();
